import { render, staticRenderFns } from "./BitacoraNovedadadesExport.vue?vue&type=template&id=9906195c"
import script from "./BitacoraNovedadadesExport.vue?vue&type=script&lang=js"
export * from "./BitacoraNovedadadesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports